export default "__VITE_ASSET__B2dUoMP5__"